import { UiComponents } from "@simulanisindia/ui";

const { MainLayout } = UiComponents;

const ChildrenComponent = ({ children }) => children;

const Public = ({ children, isMobileView }) => {
  return (
    <>
      {!isMobileView ? (
        <MainLayout
          hideHeader={true}
          hideSidebar={true}
          Component={<ChildrenComponent> {children} </ChildrenComponent>}
        />
      ) : (
        <div className="mobileView">
          <ChildrenComponent> {children} </ChildrenComponent>
        </div>
      )}

    </>
  );
};

export default Public;
